import * as layoutConstants from 'constants/layoutConstants';


const initialState = {
    layoutType: layoutConstants.LAYOUT_VERTICAL,
    layoutWidth: layoutConstants.LAYOUT_WIDTH_FLUID,
    leftSideBarTheme: layoutConstants.LEFT_SIDEBAR_THEME_DEFAULT,
    leftSideBarType: layoutConstants.LEFT_SIDEBAR_TYPE_FIXED,
    showRightSidebar: false,
    menuItems: [],
    appRoutes: [],
    activatedMenuItemIds: [],
    appDashboard: []
};

export default initialState;
